export default {"src":"/_next/static/media/sand-clock.771e0715.svg","height":18,"width":17,"blurWidth":0,"blurHeight":0};